import React, { Component, Fragment } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

class InformedConsentNoRefund extends Component {

    constructor() {
        super();
        this.state = {}
    }

    render() {
        return (
            <Fragment>
                <div className="card__title">
                    <h5 className="bold-text">Formato de no Reembolso</h5>
                </div>
                <br />
                <div>
                    <span>Formato de no Reembolso</span>
                    <br />
                    <div>
                        <p>
                        <b>Variables:</b>
                        Puede Utilizar las siguientes variables para ser reemplazadas en el Texto de manera Automatica, para utilziarlas, en la Plantilla debe escribir entre llaves la variable que desea utilizar
                        </p>
                        <ul>
                            <li>
                                {'{paciente}:'} Paciente que es atendido en la Cita Médica
                            </li>
                            <li>
                                {'{procedimiento}:'} Consulta o Procedimiento que se le realiza al Paciente (Ejemplo, Gamagrafia, Consulta General)
                            </li>
                            <li>
                                {'{tipo_identidad}:'} Tipo de Documento del Paciente
                            </li>
                            <li>
                                {'{identidad}:'} Tipo y Número de Documento del Paciente
                            </li>
                            <li>
                                {'{empresa}:'} IPS o Empresa
                            </li>
                            <li>
                                {'{profesional}:'} Profesional en salud encargado del Procedimiento o Consulta
                            </li>
                            <li>
                                {'{direccion}:'} Dirección de la IPS
                            </li>
                        </ul>
                    </div>

                    <div style={{ margin: 10 }}>
                        {<CKEditor
                            style={{ width: '100%', height: '200px' }}
                            editor={ClassicEditor}
                            data={this.props.data != null ? this.props.data : null}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                this.props.handlerInformedConsentNoRefund(data);
                            }}
                        />}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default InformedConsentNoRefund;